<div class="c-product row">
  <div class="col-8 p-0">
    <div class="titulo-producto">
      {{ product.title }}
    </div>
    <ng-container *ngIf="esProductoEnVenta; else equipoEnArriendo">
      <div class="c-contenedor-tipoV">
        <div class="c-text-sub-a"> Equipo en venta</div>
      </div>
    </ng-container>
    <ng-template #equipoEnArriendo>
      <div class="c-contenedor-tipoA">
        <div class="c-text-sub"> Equipo en Arriendo</div>
      </div>
    </ng-template>
  </div>
  <div class="col-4 p-0 align-self-end" *ngIf="!bloquearCantidad">
    <img *ngIf="!isClicked" class="icn-arrow-down c-mover-derecha" src="./assets/icons/icon-arrow-down.svg" />
    <img *ngIf="isClicked" class="icn-arrow-down c-mover-derecha" src="assets/icons/icon-arrow-up.svg" />
  </div>
  <ng-container *ngIf="true">
    <div class="col-12 c-product-detail">
      <div class="row mt-16">
        <div class="col-6 p-0">
          <div class="c-texto__carro--producto">Tipo de venta</div>
        </div>
        <div class="col-6 p-0 c-texto__carro--valor tex-al-right">
          {{ product.tipoVenta | tipoVenta }}
        </div>
      </div>
      <div class="row">
        <div class="col-6 p-0">
          <div class="c-texto__carro--producto mt-16">Cantidad</div>
        </div>
        <div class="col-6 p-0 c-texto__carro--valor tex-al-right mt-16">
          <!-- input material -->
          <ng-container *ngIf="!bloquearCantidad; else soloMostrarCantidad">
            <div class="select-cantidad">
              <mat-form-field>
                <mat-select [(value)]="cantidadSeleccionada" (selectionChange)="refreshData()">
                  <mat-option *ngFor="let cantidad of cantidades" [value]="cantidad">{{ cantidad }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>
          <ng-template #soloMostrarCantidad>
            <p>{{cantidadSeleccionada}}</p>
          </ng-template>
          <!--  <div (click)="on();"  [(ngModel)]="cantidadSeleccionada" (change)="refreshData()" class="select-box-1" >
                       <div
                        [ngClass]="{'select-1':!active,'active':active}"
                        class="select-1"id="select-1"  >
                           <div   class="contenido__select-1">
                               <div class="contenido__cantidad">1 </div>
                           </div>
                           <i
                            [ngClass]="{'icon-select':!active,'icon-select-down':active}"
                           class=" icon-select rotate-down"></i>
                       </div>
                       <div
                       [ngClass]="{'opciones':!active,'opciones-active':active}"
                         id="opciones">
                          <div  class="opcion">
                              <div  *ngFor="let cantidad of product.rangoCantidades"  class="contenido-opcion">
                                {{ cantidad }}
                              </div>
                          </div>
                       </div>
                    </div> -->
        </div>
      </div>
      <div class="row">
        <div class="col p-0 align-self-start"></div>
        <div class="col p-0 align-self-end jus-right">
          <i *ngIf="!bloquearCantidad" class="icon-eliminar c-mover-derecha tex-al-right" (click)="deleteProduct()"></i>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<div class="col-5 p-0 j">
  <div [ngClass]="{ 'mt-48': distanciaOk, 'm-top-0-0': !distanciaOk }" class="c-texto__carro--valor-a">
    Valor arriendo mensual:
  </div>
</div>
<div class="col-7 p-0">
  <div [ngClass]="{ 'mt-48': distanciaOk, 'm-top-0-0': !distanciaOk }" class="c-texto-valor-neto">
    {{ valorUf | changedot }} UF + IVA<span style="font-size: 12px;"> / mes</span>
  </div>
</div>
<div class="col-4 p-0"></div>
<div class="col-8 p-0">
  <div class="c-texto-valor-peso">($ {{ valorProductoPeso }} aproximado)</div>
</div>
